<template>
	<div class="content" v-if="!readonly">
		<!-- 拖拽上传区域 -->
		<div 
			class="upload-drop-zone"
			:class="{ 'is-dragover': isDragover }"
			@dragenter.prevent="handleDragenter"
			@dragleave.prevent="handleDragleave"
			@dragover.prevent="handleDragover"
			@drop.prevent="handleDrop"
		>
			<el-upload
				ref="uploadRef"
				class="upload-demo"
				:action="url"
				:headers="headers" 
				:data="data"
				:on-success="handleSuccess"
				:on-error="handleError"
				:before-remove="handleBeforeRemove"
				:on-remove="handleRemove"
				:on-exceed="handleExceed"
				:before-upload="handleBeforeUpload"
				:show-file-list="false"
				:limit="max"
				:accept="accept"
				:file-list="fileList">
				<div class="upload-content">
					<i class="el-icon-upload upload-icon"></i>
					<div class="upload-text">
						<em>点击上传</em> 或拖拽文件到此处
					</div>
					<div class="upload-hint">支持{{ acceptText }}格式</div>
					<div class="upload-hint paste-hint" v-if="enablePaste">
						<i class="el-icon-document-copy"></i>
						{{ pasteHint || '支持 Ctrl+V 粘贴上传' }}
					</div>
				</div>
			</el-upload>
		</div>
		
		<!-- 文件列表 -->
		<div class="file-list">
			<div class="file-item" v-for="(item, index) in fileList" :key="index">
				<!-- 缩略图/图标 -->
				<div class="file-thumb" >
					<template v-if="isImage(item)">
						<!-- <img :src="item.url" class="thumb-image" /> -->
                        <el-image :src='item.url' class="thumb-image" :preview-src-list='[item.url]'></el-image>
					</template>
					<template v-else>
						<div class="readonly-file-icon">
                            <img :src="getFileIcon(item)" alt="" />
                        </div>
					</template>
				</div>
				
				<!-- 文件信息 -->
				<div class="file-info">
					<div class="file-name" :title="item.name || getFileName(item.url)">
						{{ item.name || getFileName(item.url) }}
					</div>
					<div class="file-size" v-if="item.size">{{ formatFileSize(item.size) }}</div>
				</div>
				
				<!-- 操作按钮 -->
				<div class="file-actions">
					<el-tooltip content="预览" placement="top">
						<i class="el-icon-view action-btn" @click="previewFile(item)"></i>
					</el-tooltip>
					<el-tooltip content="下载" placement="top">
						<i class="el-icon-download action-btn" @click="downLoadFile(item)"></i>
					</el-tooltip>
					<el-tooltip content="删除" placement="top">
						<i class="el-icon-delete action-btn delete" @click="removeFile(index)"></i>
					</el-tooltip>
				</div>
			</div>
		</div>
        <le-preview-img v-model="showPreviewImg" :imgList="previewList"></le-preview-img>
	</div>
	
	<!-- 只读模式 -->
	<div class="content readonly a-flex-wrap" v-else>
        <div class="readonly-file-item" v-for="(item, index) in fileList" :key="index"> 
            <template v-if="isImage(item)">
                <!-- <img :src="item.url" class="readonly-thumb-image" /> -->
                <el-image :src='item.url' class="readonly-thumb-image" :preview-src-list='[item.url]'></el-image>
            </template>
            <template v-else>
                <div class="readonly-file-icon">
                    <img :src="getFileIcon(item)" alt="">
                </div>
            </template>
            <div class="readonly-file-btn">
                <el-tooltip content="预览" placement="top">
                    <i class="el-icon-view action-btn" @click="previewFile(item)"></i>
                </el-tooltip>
                <el-tooltip content="下载" placement="top">
                    <i class="el-icon-download action-btn" @click="downLoadFile(item)"></i>
                </el-tooltip>
            </div>
        </div>
        <le-preview-img v-model="showPreviewImg" :imgList="previewList"></le-preview-img>
	</div>
</template>

<script>
import Utils from '@/utils';

export default {
	data() {
		return {
			fileList: [],
			url: this.$Config.axiosBaseUrl + this.$Config.apiUrl.uploadFile,
			headers: {
				token: Utils.getToken(),
				appId: this.$Config.appId,
			},
			data: {
				key: "company/upload",
			},
			loading: false,
			isDragover: false,
			dragCounter: 0, // 防止拖拽时闪烁
            showPreviewImg: false,
            previewList: []
		}
	},
    computed: {
        acceptText () {
            return this.accept.split(',').map(item => item.replace(/\./g, '')).join('、')
        }
    },
	props: {
		taxFiles: {
			default: () => []
		},
		max: {
			default: 10
		},
		accept: {
			default: '.pdf,.jpg,.jpeg,.png,.gif,.xlsx,.xls,.doc,.docx'
		},
		placeholder: {
			default: '支持 PDF、图片、Excel、Word 等格式'
		},
		readonly: {
			default: false
		},
		readonlyName: {
			default: '文件_'
		},
		enablePaste: {
			type: Boolean,
			default: true
		},
		pasteHint: {
			type: String,
			default: ''
		}
	},
	watch: {
		fileList: {
			handler(val) {
				this.$emit('update:taxFiles', val)
			},
			deep: true
		},
		// taxFiles: {
		// 	handler(val) {
		// 		if (val && val.length) {
		// 			this.fileList = val.map(item => ({
		// 				name: item.name,
		// 				url: item.url,
		// 				size: item.size
		// 			}))
		// 		}
		// 	},
		// 	immediate: true
		// }
	},
    created () {
        if(this.readonly){
            if(this.taxFiles && this.taxFiles.length){
                this.fileList =this.taxFiles.map(item=>{
                    return {
                        name: item.name,
                        url: item.url
                    }
                })
            }
        }
    },
	mounted() {
		if (this.enablePaste && !this.readonly) {
			this.bindPasteEvent();
		}
	},
	beforeDestroy() {
		if (this.enablePaste) {
			this.unbindPasteEvent();
		}
	},
	methods: {
		// ==================== 拖拽上传 ====================
		handleDragenter(e) {
			this.dragCounter++;
			if (e.dataTransfer.types.includes('Files')) {
				this.isDragover = true;
			}
		},
		handleDragleave(e) {
			this.dragCounter--;
			if (this.dragCounter === 0) {
				this.isDragover = false;
			}
		},
		handleDragover(e) {
			e.dataTransfer.dropEffect = 'copy';
		},
		handleDrop(e) {
			this.isDragover = false;
			this.dragCounter = 0;
			
			const files = Array.from(e.dataTransfer.files);
			if (files.length === 0) return;
			
			// 检查数量限制
			if (this.fileList.length + files.length > this.max) {
				this.$message.warning(`最多只能上传 ${this.max} 个文件，当前还可上传 ${this.max - this.fileList.length} 个`);
				return;
			}
			
			// 处理每个文件
			files.forEach(file => {
				if (this.validateFile(file)) {
					this.uploadRawFile(file);
				}
			});
		},
		triggerUpload() {
			this.$refs.uploadRef.$refs['upload-inner'].handleClick();
		},
		
		// ==================== 粘贴上传 ====================
		bindPasteEvent() {
			document.addEventListener('paste', this.handlePaste);
		},
		unbindPasteEvent() {
			document.removeEventListener('paste', this.handlePaste);
		},
		handlePaste(e) {
			if (this.fileList.length >= this.max) {
				this.$message.warning(`最多只能上传 ${this.max} 个文件`);
				return;
			}
			
			const items = e.clipboardData && e.clipboardData.items;
			if (!items) return;
			
			let hasFile = false;
			
			for (let i = 0; i < items.length; i++) {
				const item = items[i];
				
				if (item.kind === 'file') {
					hasFile = true;
					const blob = item.getAsFile();
					
					if (blob) {
						// 生成文件名
						const timestamp = new Date().getTime();
						const ext = blob.type ? blob.type.split('/')[1] : 'png';
						const filename = `paste_${timestamp}.${ext}`;
						const file = new File([blob], filename, { type: blob.type });
						
						if (this.validateFile(file)) {
							this.uploadRawFile(file);
						}
					}
				}
			}
			
			if (hasFile) {
				e.preventDefault();
			}
		},
		
		// ==================== 文件验证 ====================
		validateFile(file) {
			// 检查文件类型
			const acceptTypes = this.accept.split(',').map(t => t.trim().toLowerCase());
			const ext = '.' + file.name.split('.').pop().toLowerCase();
			const mimeType = file.type.toLowerCase();
			
			const isValidType = acceptTypes.some(type => {
				if (type.startsWith('.')) {
					return ext === type;
				}
				return mimeType.includes(type.replace('.', ''));
			});
			
			if (!isValidType) {
                if(!this.readonly) {
                    this.$message.error(`文件格式不支持：${file.name}，请上传 ${this.accept} 格式`);
                }
				return false;
			}
			
			// 检查文件大小（默认 50MB）
			const maxSize = 50 * 1024 * 1024;
			if (file.size > maxSize) {
				this.$message.error(`文件过大：${file.name}，请上传小于 50MB 的文件`);
				return false;
			}
			
			return true;
		},
		
		// ==================== 上传处理 ====================
		uploadRawFile(file) {
			const formData = new FormData();
			formData.append('file', file);
			formData.append('key', this.data.key);
			
			this.loading = true;

            this.$Axios._post({
                url: this.url,
                params: formData,
                headers: {
                    'Content-Type': 'multipart/form-data',
                    ...this.headers
                }
            }).then(res => {
                // 上传成功，添加到列表
                this.fileList.push({
                    name: file.name,
                    url: res.data,
                    size: file.size
                });
                // this.$message.success(`${file.name} 上传成功`);
            }).catch(err => {
                this.$message.error(`上传失败：${err.message}`);
            }).finally(() => {
				this.loading = false;
			});

		},
		
		handleSuccess(response, file, fileList) {
			if (response.code == 0) {
				this.fileList.push({
					name: file.name,
					url: response.data,
					size: file.size
				});
			} else {
				this.$message.error(response.msg);
			}
			this.loading = false;
		},
		handleError(err, file) {
			this.$message.error(`文件 ${file.name} 上传失败`);
			this.loading = false;
		},
		handleBeforeUpload(file) {
            console.log(file,1);
			// this.loading = true;
			// return true;
		},
		handleExceed() {
			this.$message.warning(`当前最多只允许上传 ${this.max} 个文件`);
		},
		handleBeforeRemove(file, fileList) {
			return this.$confirm(`确定移除 ${file.name}？`);
		},
		handleRemove(file, fileList) {
			const index = this.fileList.findIndex(item => item.url === file.url);
			if (index > -1) {
				this.fileList.splice(index, 1);
			}
		},
		removeFile(index) {
			this.$confirm('是否确认删除文件？', '温馨提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.fileList.splice(index, 1);
				// this.$message.success('删除成功');
			});
		},
		
		// ==================== 文件操作 ====================
		downLoadFile(datas) {
			if (!datas.url) {
				this.$message.warning('暂无可下载文件');
				return;
			}
			const timeStamp = new Date().getTime();
			const filename = this.readonlyName + '_' + this.$getDay.getTimeStampToStr(timeStamp, 'YYYY-MM-DD HH:mm:ss');
			this.$Utils.download(datas.url, filename);
		},
		previewFile(datas) {
			if (!datas.url) {
				this.$message.warning('暂无可预览文件');
				return;
			}
			
			// 图片直接预览
			// if (this.isImage(datas)) {
            //     this.showPreviewImg = true;
			//     this.previewList = [datas.url];
			// 	return;
			// }
			
			// Office 文档使用微软在线预览或本地预览组件
			const ext = this.getFileExt(datas).toLowerCase();
			if (['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'pdf'].includes(ext)) {
				// 方式1：使用微软 Office Online（需要公网可访问的URL）
				// window.open(`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(datas.url)}`, '_blank');
				
				// 方式2：使用 kkfileview 等文档预览服务
				// window.open(`http://your-kkfileview-server/onlinePreview?url=${encodeURIComponent(Base64.encode(datas.url))}`, '_blank');
				
				// 方式3：直接下载预览
				window.open(datas.url, '_blank');
			} else {
				window.open(datas.url, '_blank');
			}
		},
		
		// ==================== 工具方法 ====================
		isImage(item) {
			if (!item.url) return false;
			const imageExts = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'];
			const ext = this.getFileExt(item).toLowerCase();
			return imageExts.includes(ext);
		},
		getFileIcon(item) {
			const ext = this.getFileExt(item).toLowerCase();
			const iconMap = {
				'pdf': require('@/assets/icon/file-suffix-pdf.png'),
				'doc': require('@/assets/icon/file-suffix-doc.png'),
				'docx': require('@/assets/icon/file-suffix-docx.png'),
				'xls': require('@/assets/icon/file-suffix-xls.png'),
				'xlsx': require('@/assets/icon/file-suffix-xlsx.png'),
				'ppt': require('@/assets/icon/file-suffix-ppt.png'),
				'pptx': require('@/assets/icon/file-suffix-pptx.png'),
				'txt': require('@/assets/icon/file-suffix-txt.png'),
				'zip': require('@/assets/icon/file-suffix-zip.png'),
				'rar': require('@/assets/icon/file-suffix-rar.png'),
			};
			return iconMap[ext] || require('@/assets/icon/file-suffix-other.png')
		},
		getFileIconClass(item) {
			const ext = this.getFileExt(item).toLowerCase();
			const classMap = {
				'pdf': 'pdf',
				'doc': 'word',
				'docx': 'word',
				'xls': 'excel',
				'xlsx': 'excel',
				'ppt': 'ppt',
				'pptx': 'ppt',
				'txt': 'txt',
				'zip': 'zip',
				'rar': 'zip',
			};
			return classMap[ext] || 'default';
		},
		getFileExt(item) {
			const name = item.name || item.url || '';
			const parts = name.split('.');
			return parts.length > 1 ? parts.pop() : 'file';
		},
		getFileName(url) {
			if (!url) return '未命名文件';
			return url.split('/').pop() || '未命名文件';
		},
		formatFileSize(bytes) {
			if (!bytes) return '';
			const units = ['B', 'KB', 'MB', 'GB'];
			let size = bytes;
			let unitIndex = 0;
			while (size >= 1024 && unitIndex < units.length - 1) {
				size /= 1024;
				unitIndex++;
			}
			return size.toFixed(2) + ' ' + units[unitIndex];
		}
	}
}
</script>

<style lang="scss" scoped>
.content {
	// padding: 20px;
	width: fit-content;
	&.readonly {
		.file-list {
			margin-top: 0;
		}
	}
}

// ==================== 拖拽上传区域 ====================
.upload-drop-zone {
    width: 300px;
	border: 2px dashed #dcdfe6;
	border-radius: 8px;
	padding: 10px 0;
	text-align: center;
	background-color: #fafafa;
	transition: all 0.3s;
	cursor: pointer;
	position: relative;
	overflow: hidden;
	
	&:hover {
		border-color: #409eff;
		background-color: #f5f7fa;
	}
	
	&.is-dragover {
		border-color: #409eff;
		background-color: #ecf5ff;
		transform: scale(1.02);
		box-shadow: 0 4px 12px rgba(64, 158, 255, 0.15);
		
		.upload-icon {
			color: #409eff;
			transform: translateY(-5px);
		}
	}
	
	::v-deep .el-upload {
		width: 100%;
	}
	
	.upload-content {
		pointer-events: none;
	}
	
	.upload-icon {
		font-size: 48px;
		color: #c0c4cc;
		// margin-bottom: 16px;
		transition: all 0.3s;
	}
	
	.upload-text {
		font-size: 14px;
		color: #606266;
		// margin-bottom: 8px;
		
		em {
			color: #409eff;
			font-style: normal;
			font-weight: 500;
		}
	}
	
	.upload-hint {
		font-size: 12px;
		color: #909399;
		// margin-top: 8px;
		
		&.paste-hint {
			color: #67c23a;
			// margin-top: 12px;
			
			i {
				margin-right: 4px;
			}
		}
	}
}

// ==================== 文件列表 ====================
.file-list {
	margin-top: 20px;
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
	gap: 16px;
}

.file-item {
	background: #fff;
	border: 1px solid #ebeef5;
	border-radius: 8px;
	padding: 16px;
	display: flex;
	align-items: center;
	transition: all 0.3s;
	position: relative;
	overflow: hidden;
	
	&:hover {
		box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
		transform: translateY(-2px);
		border-color: #409eff;
		
		.file-actions {
			opacity: 1;
			visibility: visible;
		}
		
		.thumb-overlay {
			opacity: 1;
		}
	}
}

// 缩略图
.file-thumb {
	width: 60px;
	height: 60px;
	border-radius: 6px;
	overflow: hidden;
	flex-shrink: 0;
	margin-right: 12px;
	position: relative;
	cursor: pointer;
	background-color: #f5f7fa;
	display: flex;
	align-items: center;
	justify-content: center;
	
	.thumb-image {
		width: 100%;
		height: 100%;
		object-fit: cover;
		transition: transform 0.3s;
	}
	
	&:hover .thumb-image {
		transform: scale(1.1);
	}
	
	.thumb-overlay {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background: rgba(0, 0, 0, 0.5);
		display: flex;
		align-items: center;
		justify-content: center;
		opacity: 0;
		transition: opacity 0.3s;
		
		i {
			color: #fff;
			font-size: 24px;
		}
	}
}

// 文件图标
.file-icon {
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	color: #fff;
	font-size: 24px;
	position: relative;
	
	&.pdf { background: linear-gradient(135deg, #ff6b6b, #ee5a5a); }
	&.word { background: linear-gradient(135deg, #409eff, #3a8ee6); }
	&.excel { background: linear-gradient(135deg, #67c23a, #5daf34); }
	&.ppt { background: linear-gradient(135deg, #e6a23c, #cf9236); }
	&.txt { background: linear-gradient(135deg, #909399, #82848a); }
	&.zip { background: linear-gradient(135deg, #8e44ad, #7d3c98); }
	&.default { background: linear-gradient(135deg, #c0c4cc, #a6a9ad); }
	
	.file-ext {
		position: absolute;
		bottom: 4px;
		font-size: 10px;
		text-transform: uppercase;
		font-weight: bold;
		opacity: 0.9;
	}
}

// 文件信息
.file-info {
	flex: 1;
	min-width: 0;
	display: flex;
	flex-direction: column;
	justify-content: center;
	
	.file-name {
		font-size: 14px;
		color: #303133;
		font-weight: 500;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		line-height: 1.4;
	}
	
	.file-size {
		font-size: 12px;
		color: #909399;
		margin-top: 4px;
	}
}

// 操作按钮
.file-actions {
	display: flex;
	gap: 8px;
	opacity: 0;
	visibility: hidden;
	transition: all 0.3s;
	
	.action-btn {
		width: 28px;
		height: 28px;
		border-radius: 4px;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
		font-size: 14px;
		color: #606266;
		background-color: #f5f7fa;
		transition: all 0.2s;
		
		&:hover {
			background-color: #409eff;
			color: #fff;
			transform: scale(1.1);
		}
		
		&.delete:hover {
			background-color: #f56c6c;
		}
	}
}
.readonly-file-icon{
    width: 100%;
    height: 100%;
    background: #f5f5f5;
    display: flex;
    justify-content: center;
    align-items: center;
    img{
        width: 70%;
        height: 70%;
        margin: auto;
    }
}
// 只读模式下的操作按钮始终显示
.readonly {
    padding: 0;
    display: flex;
    justify-items: flex-start;
    align-items: flex-start;
	.file-actions {
		opacity: 1;
		visibility: visible;
	}
    .readonly-file-item{
        width: 80px;
        height: 80px;
        border-radius: 10px;
        margin-right: 10px;
        position: relative;
        overflow: hidden;
    }
    .readonly-file-item:hover .readonly-file-btn{
        display: flex;
    }
    .readonly-thumb-image{
        width: 100%;
        height: 100%;
    }
    
    .readonly-file-btn{
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.5);
        display: none;
        justify-content: center;
        align-items: center;
        .action-btn {
            width: 28px;
            height: 28px;
            border-radius: 4px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            font-size: 14px;
            color: #ffffff;
            // background-color: #f5f7fa;
            transition: all 0.2s;
            
            &:hover {
                background-color: #409eff;
                color: #fff;
                transform: scale(1.1);
            }
            
            &.delete:hover {
                background-color: #f56c6c;
            }
        }
    }
}

// 响应式调整
@media (max-width: 768px) {
	.file-list {
		grid-template-columns: 1fr;
	}
	
	.file-actions {
		opacity: 1;
		visibility: visible;
	}
}
</style>